import { jsx as _jsx } from "react/jsx-runtime";
import { CardMedia } from "@mui/material";
var UVCard = function (_a) {
    var manifest = _a.manifest, viewerPath = _a.viewerPath;
    return (_jsx(CardMedia, { component: "iframe", sx: { height: "100vh" }, src: viewerPath + (manifest === null || manifest === void 0 ? void 0 : manifest.uri) }, void 0));
};
export default UVCard;
